import { createGlobalStyle, media, styled } from '@nx-kit/styling';
import { Theme } from 'themes/themeTypes';
import { Heading } from 'components/atoms/Heading';

export const WrapperStyled = styled.div`
  background-color: ${(props) => props.theme.global.color.gray150};
  min-height: 100vh;
`;

export const DonateHeaderStyled = styled.div`
  width: 100%;
  height: 425px;
  background-color: ${(props) => props.theme.global.color.primary};
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  color: ${(props) => props.theme.global.color.white};
`;

export const RowButtonStyled = styled.div`
  height: 50px;
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const RowHeadlineStyled = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  margin-top: 24px;
`;

export const Icon = styled.svg`
  width: 20px;
  height: 20px;
  line {
    stroke-width: 1.5;
    stroke-linecap: round;
    stroke: currentColor;
    transition: transform 400ms ${({ theme }) => theme.global.easing.snappy};
    transform-origin: 50% 50% 0;
  }
  line:first-of-type {
    transform: rotate(45deg) translateY(4px);
  }
  line:last-of-type {
    transform: rotate(-45deg) translateY(-4px);
  }
`;

export const LinkStyled = styled.a`
  width: 46px;
  height: 46px;
  border-radius: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  &:link,
  &:hover,
  &:visited {
    text-decoration: none;
    color: ${(props) => props.theme.global.color.primary};
    background-color: ${(props) => props.theme.global.color.white};
  }

  p {
    display: none;
  }

  ${media('md')} {
    width: 143px;
    height: 46px;
    border-radius: 6px;

    p {
      display: block;
    }

    ${Icon} {
      margin-left: 12px;
    }
  }
`;

export const HeadingStyled = styled(Heading)`
  max-width: 800px;
  text-align: center;
`;

export const SubHeadlineStyled = styled.p`
  max-width: 600px;
  text-align: center;
  font-size: 20px;
  line-height: 30px;
`;

export const DonateFormCSS = createGlobalStyle<{ theme: Theme }>`
  :root {
    --tamaro-checkable-color__checked: ${({ theme }) => theme.global.color.primary} !important;
  }

  #tamaro-widget.tamaro-widget {
    background-color: transparent !important;
    font-family: DIN,Helvetica,Arial,sans-serif !important;

    .widget-block {
      background-color: white !important;
      padding: 28px !important;
      ${media('md')} {
        padding: 60px !important;
      }
      border-radius: 8px !important;

      .title {
        min-height: 34px !important;
        .position {
          display: none !important;
        }
        .text {
          font-weight: 700 !important;
          font-size: 28px !important;
          margin-left: 0 !important;
        }
      }
    }

    .btn-primary, .btn {
      background-color: ${({ theme }) => theme.global.color.primary} !important;
      border-color: ${({ theme }) => theme.global.color.primary} !important;
      outline: 0 solid ${({ theme }) => theme.global.color.primary} !important;
      transition: outline-width 100ms ${({ theme }) => theme.global.easing.snappy} !important;

      &:hover {
          outline-width: 2px !important;
          box-shadow: none !important;
      }
    }

  }
`;
